export * from './useDTSLegalMentionsAssets';
export * from './useVATLegalMentionsAssets';
